import React, { useEffect } from "react"
import "twin.macro"
import { Button, ButtonTheme } from "../formElements/button"
import { useTranslation } from "next-i18next"
import { Routes } from "../../routes"
import router from "next/router"
import animationData from "../../assets/question/paper_airplane_horizontal.json"
import { LottieAnimation } from "../lottieAnimation"
import { AuthRoleType, ProfileOnGetProfileFragment } from "../../graphql/generated/graphql"
import Link from "next/link"

interface ThankYouProps {
  questionId: string
  profile: ProfileOnGetProfileFragment
  setQuestionBody: React.Dispatch<React.SetStateAction<string>>
  setShow: React.Dispatch<React.SetStateAction<boolean>>
}
export const ThankYou = ({ questionId, profile, setQuestionBody, setShow }: ThankYouProps) => {
  const { t } = useTranslation("profile")
  const name = profile.name ?? profile.username
  const isFree = profile.price === 0 || !profile.price
  const isDiscounted = profile?.authRole === AuthRoleType.Staff

  useEffect(() => setQuestionBody(""), [])

  return (
    <div tw="space-y-12" data-testid="thank-you">
      <div tw="space-y-3">
        <h3 tw="title-3 text-center">{t("ask_question.thank_you")}</h3>
        <p tw="text-center">{t("ask_question.submitted", { name })}</p>
      </div>

      <div tw="flex justify-center">
        <LottieAnimation data-chromatic="ignore" width="234px" height="auto" animationData={animationData} />
      </div>

      <p data-testid={isDiscounted || isFree ? `free-note` : `payment-note`} tw="text-sm font-bold text-center">
        {isDiscounted || isFree ? t("ask_question.free_note") : t("ask_question.payment_note")}
      </p>

      <div tw="w-full flex flex-col justify-center items-center">
        <div tw="flex flex-col space-y-2">
          <Button
            dataTestId="view-question"
            action={t("ask_question.view_question")}
            onClickAsync={async () =>
              void router.push({
                pathname: Routes.ShowQuestion,
                query: { id: questionId },
              })
            }
          />
          <Link href={`${profile.username}${Routes.AskQuestionForm}`} passHref>
            <a>
              <Button
                theme={ButtonTheme.PrimaryGhost}
                dataTestId="ask-another-question"
                action={t("ask_question.ask_another")}
                onClick={() => setShow(false)}
              />
            </a>
          </Link>
        </div>
      </div>
    </div>
  )
}
